import { render, staticRenderFns } from "./ProfilePortfolioSection.vue?vue&type=template&id=4d1be200&scoped=true&"
import script from "./ProfilePortfolioSection.vue?vue&type=script&lang=js&"
export * from "./ProfilePortfolioSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePortfolioSection.vue?vue&type=style&index=0&id=4d1be200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1be200",
  null
  
)

export default component.exports